// AlignUI · иллюстрация пустого состояния: планшет с лампочкой: это вопрос, а не отчёт
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationПомощник(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 148' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <rect
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        x='35.2483'
        y='40.1309'
        width='65.9741'
        height='83.2222'
        rx='3.05155'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M42.4998 36.3839V105.578C42.4998 111.643 47.4129 116.556 53.4778 116.556H100.937C105.102 116.556 108.474 113.184 108.474 109.018V36.3839C108.474 34.6979 107.109 33.3323 105.423 33.3323H45.5514C43.8654 33.3323 42.4998 34.6979 42.4998 36.3839Z'
        strokeMiterlimit='10'
      />
      <rect
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        x='62.0712'
        y='29.0148'
        width='26.8307'
        height='8.63836'
        rx='1.52577'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M70 25.5C70 22.4624 72.4624 20 75.5 20C78.5376 20 81 22.4624 81 25.5V29H70V25.5Z'
        strokeMiterlimit='10'
      />
      <circle className='fill-illustration-white-0' cx='75.4863' cy='24.9912' r='2.4912' />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M108.861 40.1308H112.664C114.349 40.1308 115.715 41.4971 115.715 43.1824V57.7953C115.715 59.4807 114.349 60.8469 112.664 60.8469H108.861V40.1308Z'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M108.861 87.9605H112.664C114.349 87.9605 115.715 89.3267 115.715 91.012V105.625C115.715 107.31 114.349 108.677 112.664 108.677H108.861V87.9605Z'
        strokeMiterlimit='10'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M60.0378 59.3695H55.1446'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M54.7702 59.1298C53.3219 58.1063 52.4533 56.3195 52.7591 54.3524C53.0902 52.2263 54.8624 50.5292 56.9999 50.2788C59.9668 49.9306 62.4844 52.2402 62.4844 55.137C62.4844 56.7884 61.6639 58.2458 60.4105 59.1315C60.1854 59.2905 60.0378 59.5368 60.0378 59.8124V62.069C60.0378 63.1953 59.1252 64.1078 57.9989 64.1078H57.1834C56.0572 64.1078 55.1446 63.1953 55.1446 62.069V59.8157C55.1446 59.5376 54.9961 59.2897 54.7702 59.1298Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M64.1156 51.0594L65.0861 50.0889'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M51.067 59.2146L50.0965 60.1851'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M51.8823 50.2439L50.9119 49.2734'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M64.1156 59.2146L65.0861 60.1851'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M64.931 55.137H66.3093'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M48.8732 55.137H50.2514'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M55.1446 61.6614H59.9318'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-soft-200'
        x='71.2358'
        y='51.308'
        width='29.1287'
        height='3.70136'
        rx='0.762887'
      />
      <rect
        className='fill-illustration-soft-200'
        x='71.2358'
        y='58.5266'
        width='16.8086'
        height='3.70136'
        rx='0.762887'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M53.4777 116.556L105.453 116.533C109.039 116.533 111.945 113.634 111.945 110.048C111.945 106.867 109.641 104.212 106.613 103.671L106.407 103.632L55.6901 94.8134C60.7022 95.8357 64.4633 100.26 64.4633 105.578C64.4633 111.643 59.5502 116.556 53.4777 116.556Z'
        strokeMiterlimit='10'
      />
      <circle
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        cx='108.861'
        cy='34.7224'
        r='12.2593'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-strong-400'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M100.987 44.1197C101.331 40.3848 104.272 37.4021 107.988 36.9943C106.009 36.5905 104.519 34.8393 104.519 32.7402C104.519 30.3423 106.463 28.3985 108.861 28.3985C111.258 28.3985 113.202 30.3423 113.202 32.7402C113.202 34.8393 111.713 36.5905 109.733 36.9943C113.449 37.402 116.39 40.3847 116.734 44.1195C114.604 45.906 111.858 46.9817 108.861 46.9817C105.863 46.9817 103.117 45.906 100.987 44.1197Z'
      />
      <path
        className='fill-illustration-strong-400'
        d='M107.988 36.9943L108.043 37.4913C108.288 37.4644 108.477 37.2633 108.488 37.0172C108.499 36.7712 108.33 36.5536 108.088 36.5044L107.988 36.9943ZM100.987 44.1197L100.489 44.0738C100.474 44.2371 100.54 44.3974 100.666 44.5028L100.987 44.1197ZM109.733 36.9943L109.633 36.5043C109.392 36.5536 109.222 36.7712 109.233 37.0172C109.245 37.2633 109.434 37.4644 109.678 37.4913L109.733 36.9943ZM116.734 44.1195L117.055 44.5026C117.181 44.3972 117.247 44.2369 117.232 44.0737L116.734 44.1195ZM107.934 36.4973C103.982 36.9309 100.855 40.1019 100.489 44.0738L101.485 44.1655C101.807 40.6677 104.563 37.8732 108.043 37.4913L107.934 36.4973ZM104.019 32.7402C104.019 35.0816 105.68 37.0339 107.888 37.4842L108.088 36.5044C106.337 36.1471 105.019 34.597 105.019 32.7402H104.019ZM108.861 27.8985C106.187 27.8985 104.019 30.0662 104.019 32.7402H105.019C105.019 30.6185 106.739 28.8985 108.861 28.8985V27.8985ZM113.702 32.7402C113.702 30.0662 111.535 27.8985 108.861 27.8985V28.8985C110.982 28.8985 112.702 30.6185 112.702 32.7402H113.702ZM109.833 37.4842C112.041 37.0338 113.702 35.0816 113.702 32.7402H112.702C112.702 34.597 111.385 36.1471 109.633 36.5043L109.833 37.4842ZM117.232 44.0737C116.866 40.1018 113.739 36.9309 109.787 36.4972L109.678 37.4913C113.159 37.8731 115.914 40.6676 116.236 44.1654L117.232 44.0737ZM116.413 43.7364C114.37 45.4502 111.736 46.4817 108.861 46.4817V47.4817C111.98 47.4817 114.839 46.3618 117.055 44.5026L116.413 43.7364ZM108.861 46.4817C105.985 46.4817 103.352 45.4503 101.309 43.7366L100.666 44.5028C102.883 46.3618 105.741 47.4817 108.861 47.4817V46.4817Z'
      />
      <circle
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        cx='39.1385'
        cy='93.2166'
        r='12.2593'
        strokeMiterlimit='10'
      />
      <path
        className='fill-illustration-strong-400'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.2651 102.614C31.6089 98.8793 34.5497 95.8968 38.2652 95.4885C36.2858 95.0843 34.7967 93.3334 34.7967 91.2347C34.7967 88.8368 36.7406 86.8929 39.1384 86.8929C41.5363 86.8929 43.4801 88.8368 43.4801 91.2347C43.4801 93.3334 41.991 95.0843 40.0118 95.4885C43.7273 95.8967 46.6681 98.8791 47.0119 102.614C44.882 104.4 42.1359 105.476 39.1384 105.476C36.1411 105.476 33.395 104.4 31.2651 102.614Z'
      />
      <path
        className='fill-illustration-strong-400'
        d='M38.2652 95.4885L38.3198 95.9855C38.5646 95.9586 38.7533 95.7575 38.7646 95.5115C38.776 95.2655 38.6065 95.0479 38.3652 94.9986L38.2652 95.4885ZM31.2651 102.614L30.7672 102.568C30.7522 102.731 30.8182 102.892 30.9438 102.997L31.2651 102.614ZM40.0118 95.4885L39.9117 94.9986C39.6704 95.0479 39.501 95.2655 39.5123 95.5115C39.5236 95.7575 39.7124 95.9586 39.9572 95.9855L40.0118 95.4885ZM47.0119 102.614L47.3333 102.997C47.4589 102.891 47.5249 102.731 47.5098 102.568L47.0119 102.614ZM38.2106 94.9915C34.2593 95.4257 31.1328 98.5964 30.7672 102.568L31.763 102.66C32.085 99.1621 34.84 96.3679 38.3198 95.9855L38.2106 94.9915ZM34.2967 91.2347C34.2967 93.5757 35.9577 95.5276 38.1651 95.9784L38.3652 94.9986C36.614 94.641 35.2967 93.0911 35.2967 91.2347H34.2967ZM39.1384 86.3929C36.4644 86.3929 34.2967 88.5607 34.2967 91.2347H35.2967C35.2967 89.1129 37.0167 87.3929 39.1384 87.3929V86.3929ZM43.9801 91.2347C43.9801 88.5607 41.8124 86.3929 39.1384 86.3929V87.3929C41.2601 87.3929 42.9801 89.1129 42.9801 91.2347H43.9801ZM40.1118 95.9784C42.3192 95.5276 43.9801 93.5756 43.9801 91.2347H42.9801C42.9801 93.0911 41.6628 94.641 39.9117 94.9986L40.1118 95.9784ZM47.5098 102.568C47.1441 98.5962 44.0177 95.4256 40.0664 94.9915L39.9572 95.9855C43.4369 96.3678 46.192 99.162 46.5141 102.659L47.5098 102.568ZM46.6906 102.231C44.6474 103.944 42.014 104.976 39.1384 104.976V105.976C42.2577 105.976 45.1167 104.856 47.3333 102.997L46.6906 102.231ZM39.1384 104.976C36.2629 104.976 33.6296 103.944 31.5864 102.231L30.9438 102.997C33.1604 104.856 36.0193 105.976 39.1384 105.976V104.976Z'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M22.8672 46.7409C22.8672 46.7409 16.8672 46.7612 16.8672 52.7408C16.8672 46.7612 10.8672 46.7409 10.8672 46.7409C10.8672 46.7409 16.8672 46.7204 16.8672 40.7408C16.8672 46.7204 22.8672 46.7409 22.8672 46.7409Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M141.138 95.3675C141.138 95.3675 135.138 95.3879 135.138 101.367C135.138 95.3879 129.138 95.3675 129.138 95.3675C129.138 95.3675 135.138 95.347 135.138 89.3674C135.138 95.347 141.138 95.3675 141.138 95.3675Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle className='fill-illustration-soft-200' cx='58.7456' cy='80.082' r='3.41203' />
      <circle className='fill-illustration-soft-200' cx='75.4869' cy='80.082' r='3.41203' />
      <circle className='fill-illustration-soft-200' cx='92.2287' cy='80.082' r='3.41203' />
    </svg>
  );
}
